import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "24",
  width: "24",
  id: "View-Off--Streamline-Ultimate",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "View Off Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("g", { id: "View-Off--Streamline-Ultimate" }, [
      _createElementVNode("path", {
        d: "M23.19 10.51a20.64 20.64 0 0 0 -4.3 -3.59l4 -4a0.91 0.91 0 0 0 -0.05 -1.34 0.87 0.87 0 0 0 -1.31 0L2 21.07a1 1 0 1 0 1.35 1.35l4.15 -4.15a10.85 10.85 0 0 0 4.61 0.94c4.25 0 8.49 -3 11 -5.8a2.16 2.16 0 0 0 0.08 -2.9Zm-6.88 2.72a4.59 4.59 0 0 1 -3 3 4.3 4.3 0 0 1 -3.1 -0.19 0.24 0.24 0 0 1 -0.06 -0.4l5.55 -5.56a0.25 0.25 0 0 1 0.41 0.06 4.3 4.3 0 0 1 0.2 3.09Z",
        fill: "currentcolor",
        "stroke-width": "1"
      }),
      _createElementVNode("path", {
        d: "M7.61 13.36a0.24 0.24 0 0 0 0.07 -0.24A4 4 0 0 1 7.5 12 4.51 4.51 0 0 1 12 7.46a4 4 0 0 1 1.16 0.18 0.26 0.26 0 0 0 0.24 -0.06l1.95 -1.95a0.26 0.26 0 0 0 -0.11 -0.42 10.58 10.58 0 0 0 -3.24 -0.5c-4.3 0 -8.6 3 -11.19 5.8a2.16 2.16 0 0 0 0 2.9 21.36 21.36 0 0 0 3.43 3 0.26 0.26 0 0 0 0.33 0Z",
        fill: "currentcolor",
        "stroke-width": "1"
      })
    ], -1)
  ])))
}
export default { render: render }